import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    businessName: '',
    merchantId: 0,
    authority: [],
    roleName: '',
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
        setUser: (_, action) => action.payload,
        updateBusinessName: (state, action) => {
            state.businessName = action.payload
        },
        userLoggedOut: () => initialState,
	},
})

export const { setUser, updateBusinessName, userLoggedOut } = userSlice.actions

export default userSlice.reducer